const defultConfig = {
  useCustomSettings: false,
  DefaultNeedVerifyCode: false,
  DomainList: '',
  HideSaveUsername: false
}

const serverConfig = window.serverConfig || {}

const config = {
  ...defultConfig,
  ...serverConfig
}

function getItem(key) {
  return config[key] || undefined
}

/**
 * @title 通讯录的显示隐藏配置
 * @description 返回对应通讯录类型下的属性显示配置
 * @param {String} type 通讯录类型，必填项。oab-组织通讯录 / ldvcapp-个人通讯录
 * @param {String} attr 通讯录属性，可选项。默认返回组织通讯录下所有的属性展示状态
 */
function contactsAttrShow(type, attr) {
  const isConfigShow = function(attr, confKey, defaultValue = true, defaultSplit = new RegExp('\\s+')) {
    const confValue = config[confKey]
    return typeof (confValue) === 'undefined' ? defaultValue : !!~confValue.trim().split(defaultSplit).indexOf(attr)
  }
  let result = {}
  switch (type) {
    case 'ldvcapp': // 个人通信录的属性
      result = {
        groups: isConfigShow('groups', 'ContactsEditFieldsOpt'),
        orgname: isConfigShow('ORGNAME', 'ContactsEditFieldsOpt'),
        mobile_number: isConfigShow('TEL;CELL;VOICE', 'ContactsEditFieldsOpt'),
        company_phone: isConfigShow('TEL;WORK;VOICE', 'ContactsEditFieldsOpt'),
        home_phone: isConfigShow('TEL;HOME;VOICE', 'ContactsEditFieldsOpt'),
        fax_number: isConfigShow('TEL;WORK;FAX', 'ContactsEditFieldsAdv')
      }
      break
    case 'oab': // 组织通信录的属性
      result = {
        mobile_number: isConfigShow('mobile_number', 'OabViewAttr'),
        company_phone: isConfigShow('company_phone', 'OabViewAttr'),
        home_phone: isConfigShow('home_phone', 'OabViewAttr'),
        fax_number: isConfigShow('fax_number', 'OabViewAttr')
      }
      break
  }
  return attr ? result[attr] : result
}

module.exports = {
  getItem,
  contactsAttrShow
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/serverConfig.js